import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import mapboxgl from "mapbox-gl";
import { point, distance } from "@turf/turf";
import axios, { CancelToken } from "axios";
import $ from "jquery";

import { I18n } from "react-redux-i18n";

import MapboxExtensions from "./mapboxExtensions/MapboxExtensions";
import ChargerDetails from "./chargerInfo/ChargerDetails";
import Filter from "./filter/Filter";
import Favorites from "./favorites/Favorites";

import { setAlert } from "../../actions/alertActions";
import {
  MAPBOX_TOKEN,
  parseAddress,
  mapsGeocode,
  calculateDistance,
  getPlug,
  getVehicleType,
  getParkingType,
} from "../utils/Utils";

import "mapbox-gl/dist/mapbox-gl.css";
import "mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "../../styles/components/map/Map.scss";
import filter from "../../styles/images/filter.svg";
import favorites from "../../styles/images/favorites.svg";
import public_station from "../../styles/images/stations/public_station.svg";
import public_station_selected from "../../styles/images/stations/public_station_selected.svg";
import evio_station from "../../styles/images/stations/evio_station.svg";
import evio_station_selected from "../../styles/images/stations/evio_station_selected.svg";
import tesla_station from "../../styles/images/stations/tesla_station.svg";
import tesla_station_selected from "../../styles/images/stations/tesla_station_selected.svg";
import salvadorCaetano_station from "../../styles/images/stations/go_charge_off.svg";
import salvadorCaetano_station_selected from "../../styles/images/stations/go_charge_filter_selected.svg";
import private_station from "../../styles/images/stations/private_station.svg";
import private_station_selected from "../../styles/images/stations/private_station_selected.svg";
import evio_o_faded from "../../styles/images/evio_o_faded.svg";
import ClusterCard from "../utils/components/ClusterCard";
import Charger from "../utils/classes/Charger";
import Cluster from "../utils/classes/Cluster";

const PLUG_STATUS = {
  AVAILABLE: "10",
  IN_USE: "20",
  BOOKED: "30",
  OFFLINE: "50",
};

const typeTimeout = 1 * 1000; // 1 second

class Map extends Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.cancel = null;
    this.inputRef = null;
    this.typeTimer = null;

    mapboxgl.accessToken = this.props.brand.tokenMapBox || MAPBOX_TOKEN;

    this.state = {
      isLoading: false,

      map: null,
      geojson: null,
      lat: 41.172707,
      lng: -8.680059,
      zoom: 14,

      geocoderInput: "",
      showExtensions: false,
      showAutocomplete: false,
      suggestions: [],
      selectedSuggestion: -1,
      gcHistory: [],
      gcChargersHistory: [],

      stations: [],
      totalEvioStations: 0,
      selectedCharger: null,

      geolocated: false,
      geoLat: 0,
      geoLng: 0,

      direction: null,
      startLat: 0,
      startLng: 0,
      visibleDistance: 2000, // in meters

      sidebar: false,
      filter: false,
      favorites: false,
      displayClusterList: false,

      filters: {
        tariffType: "",
        availableStations: "",
        sliders: {
          price: { value: 0, min: 0, max: 2, step: 0.01 },
          power: { value: 0, min: 0, max: 300, step: 0.5 },
        },
        rating: 0,
        stations: {
          ...(this.props.brand?.brandName === "EVIO" && {
            tesla: {
              selected: false,
              icons: [tesla_station, tesla_station_selected],
            },
          }),
          ...(this.props.brand?.brandName === "Salvador Caetano" && {
            goCharge: {
              selected: false,
              icons: [
                salvadorCaetano_station,
                salvadorCaetano_station_selected,
              ],
            },
          }),
          ...(this.props.brand?.brandName === "KLC" && {
            klc: {
              selected: false,
              icons: [evio_station, evio_station_selected],
            },
          }),
          public: {
            selected: false,
            icons: [public_station, public_station_selected],
          },
          evio: {
            selected: false,
            icons: [evio_station, evio_station_selected],
          },
          private: {
            selected: false,
            icons: [private_station, private_station_selected],
          },
        },
        plugs: getPlug("all"),
        parkingTypes: getParkingType("all"),
        vehicleTypes: getVehicleType("all"),
      },
      favoritesList: [],
      clusterList: [],
      showMapExtension: false,
      key: "location",
    };

    this.wrapperRef = React.createRef();

    this.initializeMap = this.initializeMap.bind(this);
    this.queryGeocoder = this.queryGeocoder.bind(this);
    this.autocompleteQuery = this.autocompleteQuery.bind(this);
    this.autocompleteChargersQuery = this.autocompleteChargersQuery.bind(this);
    this.getUserLocation = this.getUserLocation.bind(this);
    this.loadMarkers = this.loadMarkers.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleGeocodeInputChange = this.handleGeocodeInputChange.bind(this);
    this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
    this.handleChargerClick = this.handleChargerClick.bind(this);
    this.handleToggleSwitch = this.handleToggleSwitch.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.handleSelectStation = this.handleSelectStation.bind(this);
    this.handleSelectTariffType = this.handleSelectTariffType.bind(this);
    this.handlePlugClick = this.handlePlugClick.bind(this);
    this.handleParkingTypeClick = this.handleParkingTypeClick.bind(this);
    this.handleVehicleTypeClick = this.handleVehicleTypeClick.bind(this);
    this.createMarkerElement = this.createMarkerElement.bind(this);
    this.resetSelectedMarkers = this.resetSelectedMarkers.bind(this);
    this.fetchStations = this.fetchStations.bind(this);
    this.fetchFavorites = this.fetchFavorites.bind(this);
    this.toggleFavorite = this.toggleFavorite.bind(this);
    this.spreadCoords = this.spreadCoords.bind(this);
    this.updateCoords = this.updateCoords.bind(this);
    this.updateZoom = this.updateZoom.bind(this);
    this.handleClusterSelection = this.handleClusterSelection.bind(this);
    this.getHomeLocation = this.getHomeLocation.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.getHomeLocation();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps?.places?.length !== this.props.places?.length &&
      this.props.places
    ) {
      const idx = this.props.places
        ? this.props.places.findIndex(
            (p) => p.name === "home" || p.type === "HOME"
          )
        : -1;
      if (idx !== -1) {
        const center = this.props.places[idx].geometry.coordinates;
        this.state.map?.flyTo({ center, zoom: this.state.zoom });
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (this.cancel) this.cancel("Component is unmounting.");
  }

  getUserLocation(position) {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    this.safeSetState(
      {
        lat: lat,
        lng: lng,
        geolocated: true,
        geoLat: lat,
        geoLng: lng,
      },
      this.initializeMap
    );
  }

  getHomeLocation() {
    const idx = this.props.places
      ? this.props.places.findIndex(
          (p) => p.name === "home" || p.type === "HOME"
        )
      : -1;

    if (idx !== -1 && this.props.places[idx].geometry?.coordinates) {
      const coords = this.props.places[idx].geometry.coordinates;

      this.safeSetState(
        { lng: coords[0], lat: coords[1], zoom: 15 },
        this.initializeMap
      );
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.getUserLocation,
        this.initializeMap
      );
    } else {
      this.initializeMap();
    }
  }

  initializeMap() {
    this.safeSetState(
      {
        map: new mapboxgl.Map({
          container: this.mapContainer,
          style: "mapbox://styles/evioadmin/ck9n0oy82423g1inp0fngkjlr",
          center: [this.state.lng, this.state.lat],
          zoom: this.state.zoom,
          attributionControl: false,
          logoPosition: "bottom-right",
        }).addControl(new mapboxgl.NavigationControl(), "bottom-right"),
      },
      () => {
        this.state.map.on("load", () => {
          this.fetchStations(
            this.state.lat,
            this.state.lng,
            this.state.visibleDistance,
            this.state.filter
          );
          this.fetchFavorites();
        });

        this.state.map.on("move", () => {
          const lat = this.state.map.getCenter().lat.toFixed(4);
          const lng = this.state.map.getCenter().lng.toFixed(4);
          this.updateCoords(lat, lng);

          const zoom = this.state.map.getZoom().toFixed(2);
          if (zoom !== this.props.zoom) this.updateZoom(zoom);
        });

        this.state.map.on("movestart", (data) => {});

        this.state.map.on("moveend", (data) => {
          this.safeSetState(
            {
              visibleDistance:
                this.calculateDistanceVisible(data.target.transform.center) *
                1000,
            },
            () => {
              if (this.mapShouldUpdate(data.target.transform.center)) {
                this.fetchStations(
                  this.state.lat,
                  this.state.lng,
                  this.state.visibleDistance
                );
              }
            }
          );
        });

        this.state.map.on("click", (data) => {
          if (!this.state.filter && !this.state.favorites) {
            this.safeSetState(
              {
                selectedCharger: null,
                sidebar: false,
                showExtensions: false,
                displayClusterList: false,
              },
              () => {
                this.resetSelectedMarkers();
                setTimeout(() => this.state.map.resize(), 1000);
              }
            );
          }
        });
      }
    );
  }

  queryGeocoder(e, query, country, key) {
    mapsGeocode(parseAddress(query), country)
      .then((res) => {
        if (res.status === 200)
          if (res.data.status === "OK") {
            const { formatted_address, geometry, types } = res.data.results[0];
            this.safeSetState(
              (prevState) => ({
                geocoderInput: formatted_address,
                ...(key === "location" && {
                  gcHistory:
                    prevState.gcHistory.length === 3
                      ? [
                          formatted_address,
                          ...prevState.gcHistory
                            .filter((item) => item !== formatted_address)
                            .splice(0, prevState.gcHistory.length - 1),
                        ]
                      : [
                          formatted_address,
                          ...prevState.gcHistory.filter(
                            (item) => item !== formatted_address
                          ),
                        ],
                }),
                ...(key === "chargingStations" && {
                  gcChargersHistory:
                    prevState.gcChargersHistory.length === 3
                      ? [
                          formatted_address,
                          ...prevState.gcChargersHistory
                            .filter((item) => item !== formatted_address)
                            .splice(0, prevState.gcChargersHistory.length - 1),
                        ]
                      : [
                          formatted_address,
                          ...prevState.gcChargersHistory.filter(
                            (item) => item !== formatted_address
                          ),
                        ],
                }),
              }),
              () => {
                this.safeSetState(
                  { showExtensions: false, showAutocomplete: false },
                  () => {
                    if (this.inputRef !== null)
                      $(this.inputRef).trigger("blur");
                    this.state.map.flyTo({
                      center: [geometry.location.lng, geometry.location.lat],
                      zoom:
                        types[0] === "locality"
                          ? 13
                          : this.state.zoom < 15
                          ? 15
                          : this.state.zoom,
                    });
                  }
                );
              }
            );
          } else if (res.data.status === "ZERO_RESULTS") {
            this.props.setAlert(I18n.t("map_unknownLocation"), "danger");
          }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  autocompleteQuery() {
    axios
      .get("/api/private/proxy", {
        params: {
          type: "MAPS",
          url: `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodeURIComponent(
            this.state.geocoderInput
          )}&language=${this.props.locale}`,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200)
          if (res.data.status === "OK") {
            this.safeSetState({
              suggestions: res.data.predictions,
              showAutocomplete: true,
            });
          } else if (res.data.status === "ZERO_RESULTS") {
            this.safeSetState({ suggestions: [], showAutocomplete: true });
          }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  autocompleteChargersQuery() {
    axios
      .get("/api/private/chargers/searchByName", {
        params: {
          name: `${encodeURIComponent(this.state.geocoderInput)}`,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ suggestions: res.data, showAutocomplete: true });
        } else if (res.data.status === "ZERO_RESULTS") {
          this.safeSetState({ suggestions: [], showAutocomplete: true });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  calculateDistanceVisible(center) {
    const bounds = this.state.map.getBounds();
    let from = point([bounds._sw.lng, bounds._sw.lat]);
    let to = point([center.lng, center.lat]);
    return distance(from, to, { units: "kilometers" });
  }

  calculateDistanceTraveled(center) {
    let from = point([this.state.startLng, this.state.startLat]);
    let to = point([center.lng, center.lat]);
    return distance(from, to, { units: "kilometers" });
  }

  mapShouldUpdate(center) {
    let dT = this.calculateDistanceTraveled(center);
    if (dT > 1 && this.state.zoom >= 9) return true;
    else return false;
  }

  loadMarkers() {
    if (typeof this.state.map.getSource("chargers") !== "undefined") {
      this.state.map.removeSource("chargers");
    }
    this.state.map.addSource("chargers", {
      type: "geojson",
      data: this.state.geojson,
    });

    this.state.geojson.features.map((marker) => {
      let el = this.createMarkerElement(marker);

      return new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(this.state.map);
    });
  }

  loadClusterList(atPoint) {
    const popup = new mapboxgl.Popup({ offset: 20, anchor: "left" });
    let popupList = document.createElement("div");

    ReactDOM.render(
      <div className="cluster-list">
        {this.state.clusterList.map((elt, idx) => (
          <ClusterCard
            key={elt._id}
            name={elt.name || ""}
            icon={this.iconMarker(elt)}
            onClick={(e) => this.handleClusterSelection(e, idx)}
          />
        ))}
      </div>,
      popupList
    );

    popup
      .setLngLat([atPoint.lat, atPoint.long])
      .setDOMContent(popupList)
      .addTo(this.state.map);
  }

  removeMarkers() {
    // clear markers from map
    let markers = Array.from(
      document.getElementsByClassName("mapboxgl-marker")
    );
    if (markers) markers.map((m) => m.remove());
  }

  handleGeocodeInputChange(e) {
    this.safeSetState(
      { geocoderInput: e.target.value, selectedSuggestion: -1 },
      () => {
        if (this.state.geocoderInput !== "") {
          clearTimeout(this.typeTimer);
          this.state.key === "location"
            ? (this.typeTimer = setTimeout(this.autocompleteQuery, typeTimeout))
            : (this.typeTimer = setTimeout(
                this.autocompleteChargersQuery,
                typeTimeout
              ));
        } else {
          clearTimeout(this.typeTimer);
          this.safeSetState({ suggestions: [], showAutocomplete: false });
        }
      }
    );
  }

  handleOnKeyDown(e) {
    if (e.key === "Enter") {
      if (this.state.selectedSuggestion !== -1)
        this.safeSetState(
          {
            geocoderInput:
              this.state.suggestions[this.state.selectedSuggestion].description,
          },
          () =>
            this.queryGeocoder(
              null,
              this.state.geocoderInput,
              this.props.accountData.country,
              this.state.key
            )
        );
    } else if (e.key === "Escape") {
      this.safeSetState({ showExtensions: false }, () => {
        if (this.inputRef !== null) $(this.inputRef).trigger("blur");
      });
    } else {
      if (this.state.suggestions.length !== 0) {
        if (e.key === "ArrowDown") {
          const nextIndex = this.state.selectedSuggestion + 1;
          this.safeSetState({
            selectedSuggestion:
              nextIndex === this.state.suggestions.length ? 0 : nextIndex,
          });
        } else if (e.key === "ArrowUp") {
          const nextIndex = this.state.selectedSuggestion - 1;
          this.safeSetState({
            selectedSuggestion:
              nextIndex === -1 ? this.state.suggestions.length - 1 : nextIndex,
          });
        }
      }
    }
  }

  closeOpenPopups() {
    let popups = Array.from(document.getElementsByClassName("mapboxgl-popup"));
    if (popups) popups.map((p) => p.remove());
  }

  handleClusterClick(marker) {
    this.closeOpenPopups();

    let pointCoordinates = {
      lat: Math.round(marker.geometry.coordinates[0] * 1000000) / 1000000,
      long: Math.round(marker.geometry.coordinates[1] * 1000000) / 1000000,
    };

    this.safeSetState(
      {
        clusterList: marker.properties.chargersList,
        displayClusterList: true,
      },
      () => {
        this.loadClusterList(pointCoordinates);

        this.state.map.flyTo({
          center: marker.geometry.coordinates,
          zoom: this.state.zoom < 15 ? 15 : this.state.zoom,
        });
      }
    );
  }

  iconMarker(item) {
    // create a HTML element for each feature
    var el = "Marker";

    if (item.chargerType === "009") {
      el += "Tesla";
    } else if (item.chargerType === "011") {
      el += "salvadorCaetano";
    } else if (item.chargerType === "013") {
      el += "Evio";
    } else if (
      item.hasOwnProperty("accessType") &&
      item.hasOwnProperty("createUser")
    ) {
      if (item.createUser === this.props.accountData.id) {
        el += "Private";
      } else {
        el += "Evio";
      }
    } else {
      el += "Public";
    }

    if (
      item.status === PLUG_STATUS.IN_USE ||
      item.status === PLUG_STATUS.BOOKED
    ) {
      el += "Busy";
    } else if (item.status === PLUG_STATUS.OFFLINE) el += "Offline";
    else el += "Available";

    return el;
  }

  handleChargerClick(e, marker) {
    e.stopPropagation();
    this.resetSelectedMarkers();
    this.closeOpenPopups();

    e.target.classList.add("selected");

    if (marker.properties instanceof Cluster) {
      this.handleClusterClick(marker);
    } else {
      this.fetchChargerDetails(
        marker.properties._id,
        marker.properties.chargerType,
        (properties) => {
          this.safeSetState(
            {
              selectedCharger: Object.assign({}, marker, {
                properties: Object.assign({}, properties, {
                  POIs: properties.POIs.map((poi) =>
                    Object.assign({}, poi, {
                      distance: calculateDistance(
                        [this.state.geoLat, this.state.geoLng],
                        [poi.geometry.location.lat, poi.geometry.location.lng]
                      ),
                    })
                  ),
                }),
              }),
              sidebar: true,
              filter: false,
              favorites: false,
            },
            () => {
              this.state.map.flyTo({
                center: this.state.selectedCharger.geometry.coordinates,
                zoom: this.state.zoom < 15 ? 15 : this.state.zoom,
              });
            }
          );
        }
      );
    }
  }

  handleClusterSelection(e, index) {
    let chargerSelected = this.state.clusterList[index];

    this.fetchChargerDetailsClusters(
      chargerSelected._id,
      chargerSelected.chargerType,
      (properties) => {
        this.safeSetState({
          selectedCharger: Object.assign({}, chargerSelected, {
            properties: Object.assign({}, properties, {
              POIs: properties.POIs.map((poi) =>
                Object.assign({}, poi, {
                  distance: calculateDistance(
                    [this.state.geoLat, this.state.geoLng],
                    [poi.geometry.location.lat, poi.geometry.location.lng]
                  ),
                })
              ),
            }),
          }),
          sidebar: true,
          filter: false,
          favorites: false,
        });
      }
    );
  }

  handleSelect(selectedIndex, e) {
    this.safeSetState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  handleToggleSwitch(toggleSwitch, value) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        [toggleSwitch]: value ? value : !prevState.filters[toggleSwitch],
      }),
    }));
  }

  handleSliderChange(slider, value) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        sliders: Object.assign({}, prevState.filters.sliders, {
          [slider]: Object.assign({}, prevState.filters.sliders[slider], {
            value,
          }),
        }),
      }),
    }));
  }

  handleRatingChange(value) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, { rating: value }),
    }));
  }

  handleSelectStation(k) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        stations: Object.assign({}, prevState.filters.stations, {
          [k]: Object.assign({}, prevState.filters.stations[k], {
            selected: !prevState.filters.stations[k].selected,
          }),
        }),
      }),
    }));
  }

  handleSelectTariffType(type, field) {
    if (type === this.state.filters[field]) {
      this.safeSetState((prevState) => ({
        filters: Object.assign({}, prevState.filters, {
          [field]: "",
        }),
      }));
    } else {
      this.safeSetState((prevState) => ({
        filters: Object.assign({}, prevState.filters, {
          [field]: type,
        }),
      }));
    }
  }

  handlePlugClick(plug) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        plugs: Object.assign({}, prevState.filters.plugs, {
          [plug]: Object.assign({}, prevState.filters.plugs[plug], {
            picked: !prevState.filters.plugs[plug].picked,
          }),
        }),
      }),
    }));
  }

  handleParkingTypeClick(pt) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        parkingTypes: Object.assign({}, prevState.filters.parkingTypes, {
          [pt]: Object.assign({}, prevState.filters.parkingTypes[pt], {
            picked: !prevState.filters.parkingTypes[pt].picked,
          }),
        }),
      }),
    }));
  }

  handleVehicleTypeClick(vt) {
    this.safeSetState((prevState) => ({
      filters: Object.assign({}, prevState.filters, {
        vehicleTypes: Object.assign({}, prevState.filters.vehicleTypes, {
          [vt]: Object.assign({}, prevState.filters.vehicleTypes[vt], {
            picked: !prevState.filters.vehicleTypes[vt].picked,
          }),
        }),
      }),
    }));
  }

  createMarkerElement(marker) {
    // create a HTML element for each feature
    var el = document.createElement("div");
    el.className = "marker ";

    if (marker.properties instanceof Cluster) {
      if (
        marker.properties.hasOwnProperty("network") &&
        marker.properties.network === "Tesla"
      ) {
        el.className += "tesla ";
      } else if (
        marker.properties.hasOwnProperty("network") &&
        marker.properties.network === "Go.Charge"
      ) {
        el.className += "salvadorCaetano ";
      } else if (
        marker.properties.hasOwnProperty("network") &&
        marker.properties.network === "KLC"
      ) {
        el.className += "evio ";
      } else if (
        marker.properties.hasOwnProperty("network") &&
        marker.properties.network === "EVIO"
      ) {
        el.className += "evio ";
      } else if (
        marker.properties.hasOwnProperty("network") &&
        marker.properties.network === "MobiE"
      ) {
        el.className += "mobie ";
      } else el.className += "public ";

      el.className += "cluster ";
      if (this.props.brand && el.className.includes("evio"))
        el.style.backgroundImage = `url(${
          this.props.brand.icons.mapIcons[
            `marker_${this.props.brand.brandNameMap}_cluster`
          ]
        })`;
    } else {
      if (
        marker.properties.hasOwnProperty("chargerType") &&
        marker.properties.chargerType === "009"
      ) {
        el.className += "tesla ";
      }
      if (
        marker.properties.hasOwnProperty("chargerType") &&
        marker.properties.chargerType === "011"
      ) {
        el.className += "salvadorCaetano ";
      }
      if (
        marker.properties.hasOwnProperty("chargerType") &&
        marker.properties.chargerType === "013"
      ) {
        el.className += "evio ";
      } else if (
        marker.properties.hasOwnProperty("accessType") &&
        marker.properties.hasOwnProperty("createUser")
      ) {
        if (marker.properties.createUser === this.props.accountData.id) {
          el.className += "private ";
        } else {
          el.className += "evio ";
          this.safeSetState((prevState) => ({
            totalEvioStations: prevState.totalEvioStations + 1,
          }));
        }
      } else {
        el.className += "public ";
      }

      if (
        marker.properties.status === PLUG_STATUS.IN_USE ||
        marker.properties.status === PLUG_STATUS.BOOKED
      ) {
        el.className += "busy ";
        if (this.props.brand && el.className.includes("evio"))
          el.style.backgroundImage = `url(${
            this.props.brand.icons.mapIcons[
              `marker_${this.props.brand.brandNameMap}_busy`
            ]
          })`;
      } else if (marker.properties.status === PLUG_STATUS.OFFLINE) {
        el.className += "offline ";
        if (this.props.brand && el.className.includes("evio"))
          el.style.backgroundImage = `url(${
            this.props.brand.icons.mapIcons[
              `marker_${this.props.brand.brandNameMap}_offline`
            ]
          })`;
      } else {
        el.className += "available ";
        if (this.props.brand && el.className.includes("evio"))
          el.style.backgroundImage = `url(${
            this.props.brand.icons.mapIcons[
              `marker_${this.props.brand.brandNameMap}_available`
            ]
          })`;
      }
    }

    if (this.state.selectedCharger !== null) {
      if (marker.properties._id === this.state.selectedCharger.properties._id) {
        el.classList.add("selected");
      }
    }

    el.addEventListener("click", (e) => this.handleChargerClick(e, marker));
    return el;
  }

  resetSelectedMarkers() {
    const markers = document.getElementsByClassName("marker");
    Array.from(markers).forEach((marker) => {
      marker.classList.remove("selected");
    });
  }

  fetchStations() {
    this.safeSetState(
      {
        startLat: this.state.lat,
        startLng: this.state.lng,
        isLoading: true,
      },
      () => {
        if (this.cancel) this.cancel("New request was made.");
        return axios
          .post(
            "/api/private/connectionstation/chargers",
            this.createFilterPacket(),
            {
              params: {
                lat: this.state.lat,
                lng: this.state.lng,
                distance: this.state.visibleDistance,
              },
              cancelToken: new CancelToken((c) => (this.cancel = c)),
            }
          )
          .then((res) => {
            if (res.status === 200) {
              let resWithClustersIdentified = this.checkStationsSameCoordinates(
                res.data
              );

              if (resWithClustersIdentified?.length === 0) {
                this.safeSetState({ isLoading: false });
              }

              resWithClustersIdentified.map((station, i) => {
                let plugsBusy = 0;

                if (station instanceof Charger) {
                  station.hasOwnProperty("plugs") &&
                    station.plugs.map((plug) => {
                      if (
                        plug.status === PLUG_STATUS.IN_USE ||
                        plug.status === PLUG_STATUS.BOOKED
                      )
                        plugsBusy++;
                      return plug;
                    });

                  if (plugsBusy === station.plugs.length)
                    resWithClustersIdentified[i].status = PLUG_STATUS.IN_USE;
                } else if (station instanceof Cluster) {
                  station.chargersList.map((element, j) => {
                    plugsBusy = 0;
                    element.hasOwnProperty("plugs") &&
                      element.plugs.map((plug) => {
                        if (
                          plug.status === PLUG_STATUS.IN_USE ||
                          plug.status === PLUG_STATUS.BOOKED
                        )
                          plugsBusy++;
                        return plug;
                      });

                    if (plugsBusy === element.plugs.length)
                      element.status = PLUG_STATUS.IN_USE;

                    return element;
                  });
                }
              });

              this.safeSetState(
                {
                  stations: resWithClustersIdentified,
                },
                () => {
                  this.safeSetState(
                    {
                      geojson: {
                        type: "FeatureCollection",
                        features: this.state.stations.map((station, idx) => {
                          if (station instanceof Charger) {
                            return {
                              type: "Feature",
                              properties: station,
                              geometry: {
                                type: "Point",
                                coordinates: this.spreadCoords(idx, [
                                  station.geometry.coordinates[0],
                                  station.geometry.coordinates[1],
                                ]),
                              },
                            };
                          } else if (station instanceof Cluster) {
                            return {
                              type: "Feature",
                              properties: station,
                              geometry: {
                                type: "Point",
                                coordinates: this.spreadCoords(idx, [
                                  station.geometry.coordinates[0],
                                  station.geometry.coordinates[1],
                                ]),
                              },
                            };
                          }
                        }),
                      },
                      isLoading: false,
                    },
                    () => {
                      this.removeMarkers();
                      this.loadMarkers();
                    }
                  );
                }
              );
            }
          })
          .catch((err) =>
            this.safeSetState({ isLoading: false }, () =>
              this.props.setAlert(I18n.t(err.response.data.message), "danger")
            )
          );
      }
    );
  }

  checkStationsSameCoordinates(stations) {
    let clustersList = [];
    let regularChargersList = [];
    let FinalStationsList;

    //Identify Chargers with same coordinates and establish a list of Clusters
    for (let i = 0; i < stations.length; i++) {
      for (let j = i + 1; j < stations.length; j++) {
        //check coordinates equality between element i and element j
        if (
          stations[i].geometry.coordinates[0] ===
            stations[j].geometry.coordinates[0] &&
          stations[i].geometry.coordinates[1] ===
            stations[j].geometry.coordinates[1]
        ) {
          //check if list of Clusters is empty
          if (clustersList.length === 0) {
            //push new Cluster with charger i and j
            clustersList.push(
              new Cluster(
                stations[i].geometry.coordinates,
                stations[i].network,
                [stations[i], stations[j]]
              )
            );
          }
          // if list of Clusters already has elements
          else if (clustersList.length >= 1) {
            //find index of the list where coordinates match coordinates of j
            let indexFound = clustersList.findIndex((element) => {
              return (
                element.geometry.coordinates[0] ===
                  stations[j].geometry.coordinates[0] &&
                element.geometry.coordinates[1] ===
                  stations[j].geometry.coordinates[1]
              );
            });

            //if found
            if (indexFound !== -1) {
              //check that the charger is not already in the list
              let wasFoundInChargerList = clustersList[
                indexFound
              ].chargersList.some((element) => {
                return element._id === stations[j]._id;
              });

              //if charger not found in the list of chargers add it
              if (!wasFoundInChargerList) {
                clustersList[indexFound].assignCharger(stations[j]);
              }
            } else {
              // coordinates were not found in the clusterlist so a new cluster needs to be added with both elements i and j
              clustersList.push(
                new Cluster(
                  stations[i].geometry.coordinates,
                  stations[i].network,
                  [stations[i], stations[j]]
                )
              );
            }
          }
        }
      }
    }

    //Identify regular chargers that are not part of cluster list
    if (clustersList.length > 0) {
      for (let i = 0; i < stations.length; i++) {
        let foundAtIndex = clustersList.findIndex((element) => {
          return (
            element.geometry.coordinates[0] ===
              stations[i].geometry.coordinates[0] &&
            element.geometry.coordinates[1] ===
              stations[i].geometry.coordinates[1]
          );
        });

        //if not found add the charger to the regular charger list
        if (foundAtIndex === -1) {
          regularChargersList.push(new Charger(stations[i]));
        }
      }
    } else {
      for (let i = 0; i < stations.length; i++) {
        regularChargersList.push(new Charger(stations[i]));
      }
    }

    //join both cluster and regular chargers List
    FinalStationsList = regularChargersList.concat(clustersList);

    return FinalStationsList;
  }

  fetchChargerDetails(_id, chargerType, callback) {
    axios
      .get("/api/private/connectionstation/chargerDetails", {
        params: {
          _id,
          chargerType,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const idx = this.state.stations.findIndex(
            (s) => s._id === res.data._id
          );
          if (idx !== -1) {
            this.safeSetState(
              (prevState) => ({
                stations: [
                  ...prevState.stations.slice(0, idx),
                  res.data,
                  ...prevState.stations.slice(idx + 1),
                ],
              }),
              () => callback(res.data)
            );
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchChargerDetailsClusters(_id, chargerType, callback) {
    axios
      .get("/api/private/connectionstation/chargerDetails", {
        params: {
          _id,
          chargerType,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const idx = this.state.clusterList.findIndex(
            (s) => s._id === res.data._id
          );

          if (idx !== -1) {
            this.safeSetState(
              (prevState) => ({
                clusterList: [
                  ...prevState.clusterList.slice(0, idx),
                  res.data,
                  ...prevState.clusterList.slice(idx + 1),
                ],
              }),
              () => callback(res.data)
            );
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchFavorites() {
    axios
      .get("/api/private/users/favorites", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ favoritesList: res.data });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  toggleFavorite(mode, charger) {
    if (mode === "put") {
      const put = {
        baseId: this.state.selectedCharger.properties._id,
        hwId: this.state.selectedCharger.properties.hwId,
        chargerType: this.state.selectedCharger.properties.chargerType,
      };
      axios
        .put("/api/private/users/favorites", put, {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(I18n.t(res.data?.message), "primary");
            this.fetchFavorites();
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        );
    } else if (mode === "delete") {
      let del;
      if (this.state.selectedCharger !== null)
        del = {
          baseId: this.state.selectedCharger.properties._id,
          hwId: this.state.selectedCharger.properties.hwId,
        };
      else del = { baseId: charger._id, hwId: charger.hwId };
      axios
        .delete("/api/private/users/favorites", {
          data: del,
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(I18n.t(res.data?.message), "primary");
            this.fetchFavorites();
          }
        });
    }
  }

  createFilterPacket() {
    this.safeSetState({ geojson: null });
    let stations = [];
    Object.keys(this.state.filters.stations).map(
      (s) => this.state.filters.stations[s].selected && stations.push(s)
    );

    let post = {
      ...(this.state.filters.tariffType !== "" && {
        tariffType: this.state.filters.tariffType ? "power" : "time",
      }),
      ...(this.state.filters.availableStations !== "" && {
        availableStations: [10],
      }),
      ...(this.state.filters.availableStations === "available" && {
        onlyAvailable: true,
      }),
      ...(this.state.filters.availableStations === "online" && {
        onlyOnline: true,
      }),
      ...(parseFloat(this.state.filters.sliders.price.value) !== 0.0 && {
        priceRange: {
          min: parseFloat(this.state.filters.sliders.price.value),
        },
      }),
      ...(parseFloat(this.state.filters.sliders.power.value) !== 0.0 && {
        powerRange: {
          min: 0,
          max: parseFloat(this.state.filters.sliders.power.value),
        },
      }),
      ...(this.state.filters.rating && {
        rating: this.state.filters.rating,
      }),
      ...(Object.keys(this.state.filters.stations).find(
        (s) => this.state.filters.stations[s].selected
      ) !== undefined && {
        stations,
      }),
      ...(Object.keys(this.state.filters.plugs).filter(
        (p) => this.state.filters.plugs[p].picked
      ).length !== 0 && {
        connectorType: Object.keys(this.state.filters.plugs)
          .filter((p) => this.state.filters.plugs[p].picked)
          .map((p) => this.state.filters.plugs[p].name),
      }),
      ...(Object.keys(this.state.filters.parkingTypes).filter(
        (pt) => this.state.filters.parkingTypes[pt].picked
      ).length !== 0 && {
        parkingType: Object.keys(this.state.filters.parkingTypes)
          .filter((pt) => this.state.filters.parkingTypes[pt].picked)
          .map((pt) => this.state.filters.parkingTypes[pt].camelcaseName),
      }),
      ...(Object.keys(this.state.filters.vehicleTypes).filter(
        (vt) => this.state.filters.vehicleTypes[vt].picked
      ).length !== 0 && {
        vehicles: Object.keys(this.state.filters.vehicleTypes)
          .filter((vt) => this.state.filters.vehicleTypes[vt].picked)
          .map((vt) => this.state.filters.vehicleTypes[vt].camelcaseName),
      }),
    };

    return post;
  }

  spreadCoords(idx, coords) {
    for (let i = 0; i < idx; i++) {
      if (
        calculateDistance(coords, this.state.stations[i].geometry.coordinates) <
        50
      )
        return [coords[0] - 0.0000001, coords[1] - 0.0000001];
    }
    return coords;
  }

  updateCoords(lat, lng) {
    this.safeSetState({
      lat: lat,
      lng: lng,
    });
  }

  updateZoom(zoom) {
    this.safeSetState({ zoom: zoom });
  }

  safeSetState(params, callback) {
    if (this.mounted) this.setState(params, callback);
  }

  toggleMapboxExtensions = () => {
    this.safeSetState({
      showMapExtension: true,
      selectedSuggestion: -1,
    });
  };

  handleSelectTab = (k) => {
    this.safeSetState({
      key: k,
      geocoderInput: "",
      suggestions: [],
    });
  };

  handleClickChargerDetail = (_id, chargerType) => {
    axios
      .get("/api/private/connectionstation/chargerDetails", {
        params: {
          _id,
          chargerType,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const newObjSuggestion = {
            properties: res.data,
            geometry: res.data.geometry,
          };

          this.safeSetState({
            selectedCharger: newObjSuggestion,
            sidebar: true,
            filter: false,
            favorites: false,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.safeSetState({
        showMapExtension: false,
      });
    }
  }

  render() {
    const bounds = this.state.map && this.state.map.getBounds();
    const bbox = bounds
      ? [
          Math.min(bounds._sw.lng, this.state.lng),
          Math.min(bounds._sw.lat, this.state.lat),
          Math.max(bounds._sw.lng, this.state.lng),
          Math.max(bounds._sw.lat, this.state.lat),
        ]
      : false;

    return (
      <div id="map" className="map-overview">
        {this.state.selectedCharger !== null && (
          <div className="map-backdrop" />
        )}
        <div
          ref={(el) => (this.mapContainer = el)}
          className={
            this.props.fullscreen
              ? "mapContainer mapboxgl-map fullscreen"
              : "mapContainer mapboxgl-map"
          }
        >
          <div
            id="filters-container"
            className="filters-container"
            ref={this.wrapperRef}
          >
            <input
              ref={(el) => (this.inputRef = el)}
              type="text"
              className="geocoder-input"
              placeholder={I18n.t("map_searchLocation")}
              value={this.state.geocoderInput}
              onFocus={(e) => this.safeSetState({ showExtensions: true })}
              onChange={this.handleGeocodeInputChange}
              onKeyDown={this.handleOnKeyDown}
              onClick={this.toggleMapboxExtensions}
            />
            <div className="extensions-wrapper">
              <MapboxExtensions
                places={this.props.places}
                recent={this.state.gcHistory}
                recentCharger={this.state.gcChargersHistory}
                query={this.queryGeocoder}
                suggestions={this.state.suggestions}
                selectedSuggestion={this.state.selectedSuggestion}
                show={this.state.showMapExtension}
                showAutocomplete={this.state.showAutocomplete}
                activeTab={this.handleSelectTab}
                keyTab={this.state.key}
                openChargerDetail={this.handleClickChargerDetail}
              />
            </div>

            <button
              type="button"
              className="clear"
              onClick={() =>
                this.safeSetState(
                  {
                    favorites: false,
                    filter: true,
                    sidebar: true,
                    selectedCharger: null,
                  },
                  this.resetSelectedMarkers
                )
              }
            >
              <img src={filter} alt="" />
            </button>
            <button
              type="button"
              className="clear"
              onClick={() =>
                this.safeSetState({
                  filter: false,
                  favorites: true,
                  sidebar: true,
                  selectedCharger: null,
                })
              }
            >
              <img src={favorites} alt="" />
            </button>
          </div>
        </div>
        <div className={this.state.sidebar ? "sidebar show" : "sidebar"}>
          <div className="sidebar-content">
            {this.state.selectedCharger !== null && (
              <ChargerDetails
                currentLocation={
                  this.state.geolocated
                    ? [this.state.geoLat, this.state.geoLng]
                    : false
                }
                bbox={bbox}
                charger={this.state.selectedCharger}
                favorites={this.state.favoritesList}
                toggleFavorite={this.toggleFavorite}
              />
            )}
            <Filter
              show={this.state.filter}
              onClose={() =>
                this.safeSetState({ filter: false, sidebar: false }, () =>
                  setTimeout(() => this.state.map.resize(), 1000)
                )
              }
              onApplyFilter={this.fetchStations}
              filters={this.state.filters}
              handleToggleSwitch={this.handleToggleSwitch}
              handleSliderChange={this.handleSliderChange}
              handleRatingChange={this.handleRatingChange}
              handleSelectStation={this.handleSelectStation}
              handleSelectTariffType={this.handleSelectTariffType}
              handlePlugClick={this.handlePlugClick}
              handleParkingTypeClick={this.handleParkingTypeClick}
              handleVehicleTypeClick={this.handleVehicleTypeClick}
            />
            <Favorites
              show={this.state.favorites}
              onClose={() =>
                this.safeSetState({ favorites: false, sidebar: false }, () =>
                  setTimeout(() => this.state.map.resize(), 1000)
                )
              }
              currentLocation={
                this.state.geolocated
                  ? [this.state.geoLat, this.state.geoLng]
                  : false
              }
              favorites={this.state.favoritesList}
              toggleFavorite={this.toggleFavorite}
            />
          </div>
        </div>
        <button
          id="reloadBtn"
          type="button"
          className={"clear " + (this.state.isLoading ? "loading" : "")}
          onClick={this.fetchStations}
        >
          <img
            src={this.props.brand?.icons?.principalIcon || evio_o_faded}
            alt=""
          />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  accountData: state.account.accountData,
  places: state.account.accountData.places || [],
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, { setAlert })(Map);
